<div class="container h-100">
    <div *ngIf="canShowTeams" class="h-100 w-100 d-flex flex-column align-items-center justify-content-center">
        <div class="w-100 d-flex gap-4 flex-wrap align-items-center justify-content-center">
            <span *ngFor="let teams of win_teams" class="win-team text-32-600-125">{{teams}}</span>
        </div>
        <img width="438" class="img-fluid" src="assets/images/sdg-action.png" alt="">
        <h1 *ngIf="win_teams.length > 0" class="mt-5 text-center text-40-600-120 text-c4">
                {{('Congratulations!!' | translate)}} 
                {{(win_teams.length < 2 ? win_teams[0] : ('Teams '+getTeams(win_teams)))}}
            <img class="pb-3" src="assets/icons/party-popper.svg" alt="">
        </h1>
        <h1 *ngIf="win_teams.length == 0" class="mt-5 text-center text-40-600-120 text-c4">
            {{('Congratulations on completing the quiz!' | translate)}}
            <!-- {{win_teams.length 
            ? ('Congratulations!!' | translate) 
            : ('Congratulations on completing the quiz!' | translate)}} -->
            <img class="pb-3" src="assets/icons/party-popper.svg" alt="">
        </h1>
        <p class="text-20-400-140 text-c2 text-center">
            {{win_teams.length ? ('Amazing job, champions! You’ve earned the top spot!' | translate) 
            : ('While there’s no champion this time, great effort by everyone. Keep it up!' | translate)}}
        </p>
        <button routerLink="/result" class="mt-4 qz-btn text-16-600-150">{{'View result' | translate}}</button>
        <button routerLink="/category" class="mt-4 qz-btn text-16-600-150">{{'Create new Quiz' | translate}}</button>
    </div>
    <div *ngIf="!canShowTeams" class="h-100 w-100 d-flex flex-column align-items-center justify-content-center">
        <h1 class="mt-5 text-center text-40-600-120 text-c4">
            {{"Generating result" | translate}}
            <img width="50" src="assets/images/loader.gif" alt="" class="load">
        </h1>
    </div>
</div>
